import { Icon } from '@iconify/react';
import { Avatar, Flex, Tooltip } from 'antd';
import classNames from 'classnames';
import { Link, useLocation } from 'react-router';

/**
 * Resources
 */
import MdiBullseyeArrow from '@/assets/icons/mdi--bullseye-arrow.svg?raw';
import MdiQuestionMarkCircle from '@/assets/icons/mdi--question-mark-circle.svg?raw';
import MdiSettings from '@/assets/icons/mdi--settings.svg?raw';
import MdiTodoAuto from '@/assets/icons/mdi--todo-auto.svg?raw';
import MdiViewGrid from '@/assets/icons/mdi--view-grid.svg?raw';

/**
 * Styles
 */
import styles from './styles.module.less';

/**
 * Constants
 */
const links = [
    {
        icon: { body: MdiTodoAuto },
        href: '/tasks',
        title: '任务',
    },
    {
        icon: { body: MdiViewGrid },
        href: '/matrix',
        title: '四象限',
    },
    {
        icon: { body: MdiBullseyeArrow },
        href: '/focus',
        title: '专注',
    },
];

const Page: React.FC = () => {
    /**
     * Hooks
     */
    const location = useLocation();

    return (
        <Flex justify="space-between" style={{ height: '100%' }} vertical>
            <Flex align="center" gap={24} vertical>
                {/* 头像 */}
                <Avatar size="large" src="https://files.liuuu.net/avatar/logo.png" />

                {/* 功能 */}
                <Flex align="center" gap={24} vertical>
                    {links.map((link) => (
                        <Tooltip
                            align={{ offset: [10, 0] }}
                            arrow={false}
                            key={link.href}
                            placement="right"
                            title={link.title}
                        >
                            <Link to={link.href}>
                                <Icon
                                    className={classNames(styles.icon, {
                                        [styles.active]: location.pathname === link.href,
                                    })}
                                    icon={link.icon}
                                />
                            </Link>
                        </Tooltip>
                    ))}
                </Flex>
            </Flex>

            {/* 帮助 */}
            <Flex align="center" gap={24} vertical>
                <Tooltip align={{ offset: [10, 0] }} arrow={false} placement="right" title="更多">
                    <Icon className={styles.icon} icon={{ body: MdiQuestionMarkCircle }} />
                </Tooltip>

                <Tooltip align={{ offset: [10, 0] }} arrow={false} placement="right" title="设置">
                    <Icon className={styles.icon} icon={{ body: MdiSettings }} />
                </Tooltip>
            </Flex>
        </Flex>
    );
};

export default Page;
